import React, { FC, useEffect, useState } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

type Props = {
  id: string;
  onChange: (newValue: number) => void;
  quantity: number;
  disabled?: boolean;
};

export const Incrementer: FC<Props> = ({ id, onChange, quantity, disabled }) => {
  const [inputWidth, setInputWidth] = useState(quantity > 99 ? 56 : quantity > 9 ? 46 : 40);

  const handleChange = (newQuantity: string) => {
    if (disabled) {
      return;
    }

    const newQuantityAsNumber = Number(newQuantity);

    onChange(newQuantityAsNumber > 0 ? newQuantityAsNumber : 0);
  };

  useEffect(() => {
    quantity > 99 ? setInputWidth(56) : quantity > 9 ? setInputWidth(46) : setInputWidth(40);
  }, [quantity]);

  return (
    <Box display="flex" data-testid="incrementer">
      <IconButton disabled={disabled} onClick={() => handleChange(`${quantity - 1}`)} data-testid="decrement-button">
        <RemoveCircleOutlineIcon />
      </IconButton>
      <TextField
        disabled={disabled}
        sx={{ width: inputWidth }}
        size="small"
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        id={id}
        value={quantity}
        onChange={({ target: { value } }) => handleChange(value)}
        data-testid="incrementer-textfield"
      />
      <IconButton disabled={disabled} onClick={() => handleChange(`${quantity + 1}`)} data-testid="increment-button">
        <AddCircleOutlineIcon />
      </IconButton>
    </Box>
  );
};
